import { DIV } from 'sdi/components/elements';
import tr from 'sdi/locale';
import { clearFilters, GlobalFilter, setGlobalFilter } from '../events/qa';
import {
    getGlobalFilter,
    getGlobalFilteredIssues,
    getGlobalInfoFilteredIssues,
} from '../queries/qa';
import { getFilteredAndSortedRows } from '../queries/table';

const isFilterActive = (filter: GlobalFilter) =>
    getGlobalFilter() === filter ? 'active' : '';

const nbFilteredIssues = (filter: GlobalFilter) =>
    getGlobalFilteredIssues(filter)
        .map(list => list.length)
        .getOrElse(0); // TODO

const renderFilter = (filter: GlobalFilter) =>
    DIV(
        {
            className: `link-simple global-filter ${filter} ${isFilterActive(
                filter
            )}`,
            onClick: () => {
                clearFilters();
                setGlobalFilter(filter);
            },
        },
        `${tr.qa(filter)} (${nbFilteredIssues(filter)})`
    );

export const renderGlobalFilters = () => {
    const filters: GlobalFilter[] = [
        'newOrStalled',
        'new',
        'stalled',
        'allIssues',
    ];

    return DIV(
        {
            className: 'global-filters',
        },
        DIV({ className: 'global-filters-title' }, tr.qa('issues')),
        DIV(
            { className: 'global-filters-wrapper' },
            filters.map(f => renderFilter(f))
        ),
        DIV(
            { className: 'global-filters-result' },
            `${getGlobalInfoFilteredIssues()
                .map(filtered => getFilteredAndSortedRows(filtered).length)
                .getOrElse(0)} résultats`
        )
    );
};
